
export default function (permissions) {
    let actions = [];
    for (let key in permissions) {
        if (Object.prototype.hasOwnProperty.call(permissions, key) && permissions[key]) {
            actions.push(key);
        }
    }
    return actions;
}
